<script>
  import Selector from '../lib/components/Selector.svelte';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import session from '../lib/session.js';
  import InputWithValidation from '../lib/components/InputField.svelte';
  import { APIClient } from '../state-charts';
  import Validators from '../lib/validators';
  import { onDestroy } from 'svelte';

  // component options  ------------------------------------------------------ //

  export let id;
  export let phone;
  export let valid = true;
  export let width = '291px'

  // internal variables ------------------------------------------------------ //

  let phone_number_field;
  let items = [];
  let phone_code;
  let phone_country;
  let phone_number;
  let type_text;
  let has_init = false;
  let event_flag = true;
  let error_message;
  const VALIDATION_DEBOUNCE_MS = 600;
  let phone_debounce_timer;
  let previous_country;
  let previous_number;

  // translated strings ------------------------------------------------------ //

  let phone_number_label;
  let country_code_no_choice_text;

  // utility functions -------------------------------------------------------- //

  $: if (!has_init && !!phone) {
    phone_code = phone.code;
    phone_country = phone.country;
    previous_country = phone.country;
    phone_number = phone.number;
    previous_number = phone_number;
    has_init = true;
  }

  const load_country_codes = () => {
    items = $session.api_config.phone_country_codes
      .filter(item => item.country !== 'AX')
      .map(item => {
        return { val: item.code, name: `(${item.country}) ${item.code}` };
      });
  };

  const set_country = code => {
    const base = $session.api_config.phone_country_codes.filter(
      item => item.country !== 'AX'
    );
    const i11l_code = base.find(item => item.code === code);
    phone_country = !!i11l_code ? i11l_code.country : null;
  };

  const set_phone = (country, code, number) => {
    phone = { country, code, number };
  };

  const validate_phone = async phone_obj => {
    let result = await Validators.validate_phone(phone_obj);
    valid= result.valid;
    error_message= result.error;
  };

  const translate_texts = () => {
    phone_number_label = t9n(TS.PHONE_NUMBER_LABEL);
    country_code_no_choice_text = t9n(TS.PHONE_AREA_CODE);
    type_text = t9n(TS.NATIVE_SELECT_TYPE_TEXT);
  };

  // reactive functions ------------------------------------------------------- //

  $: if (!!$session) translate_texts();

  $: if (!!$session.api_config) load_country_codes();

  $: if (!!$session.api_config) set_country(phone_code);

  $: if (!!phone_country) set_phone(phone_country, phone_code, phone_number);

  $: if (has_init && (phone_country || phone_number)) {
    if (phone_country !== previous_country || previous_number !== phone_number) {
      previous_country = phone_country;
      previous_number = phone_number;

      set_phone(phone_country, phone_code, phone_number);

      clearTimeout(phone_debounce_timer);
      const current_phone = { country: phone_country, code: phone_code, number: phone_number };
      phone_debounce_timer = setTimeout(() => {
        validate_phone(current_phone);
      }, VALIDATION_DEBOUNCE_MS);
    }
  }

  onDestroy(() => {
    clearTimeout(phone_debounce_timer);
  });
</script>

<svelte:options accessors={true} />

<div {id} class="phone-number-container">

  <div style="margin-right: 5px; width: 152px;">
    <Selector
      label={country_code_no_choice_text}
      id="phone_code_selector"
      variant={'filled'}
      is_required={true}
      bind:event_flag
      bind:value={phone_code}
      bind:items />
  </div>

  <InputWithValidation
    id='phone_number_input'
    type="tel"
    label={phone_number_label}
    name="forAutocompleteHackToWork"
    validate={false}
    is_required={true}
    bind:value={phone_number}
    valid={valid}
    variant={'filled'}
    validation_text={error_message}
    width={width} />
</div>

<style>
  .phone-number-container {
    display: flex;
  }
</style>
